"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlIsLegacy_1 = __importDefault(require("../../shared/controlIsLegacy"));
const setControlByPath = ({ control, path, controlToSet, }) => {
    if (path.length === 0) {
        return controlToSet;
    }
    const { controls } = control;
    const [currentIndex, ...restOfPath] = path;
    return Object.assign(Object.assign({}, control), { controls: controls && controls.map((controlChild, childIndex) => {
            if (!(0, controlIsLegacy_1.default)(controlChild)) {
                throw new Error('Control is not legacy');
            }
            if (childIndex === currentIndex) {
                return setControlByPath({
                    control: controlChild,
                    path: restOfPath,
                    controlToSet,
                });
            }
            return controlChild;
        }) });
};
exports.default = setControlByPath;
